import type { WorkbenchPanelContribution } from '@crowdex/plugin-contracts';
import type { SidePanelView } from '@/lib/side-panel/side-panel-items';

/**
 * The project conversation's panel tabs (D65, D67): Tasks, Project. They are panels of the core,
 * shown with a project's conversation only; on a phone the panel is the project page (mobile
 * 2e), every section in one.
 */
export const PROJECT_TASKS_VIEW = 'plugin:crowdex/project-tasks' as const;
export const PROJECT_SETTINGS_VIEW = 'plugin:crowdex/project' as const;
export const PROJECT_VIEWS: readonly SidePanelView[] = [PROJECT_TASKS_VIEW, PROJECT_SETTINGS_VIEW];

/** The core panels the workbench lists (`core-panels.ts`). */
export const PROJECT_PANELS: readonly WorkbenchPanelContribution[] = [
  { id: 'project-tasks', title: 'Tasks', icon: 'list', hostView: 'project-tasks' },
  { id: 'project', title: 'Assistant', icon: 'sliders-horizontal', hostView: 'project' },
];

/** Whether a panel view is one of the project's tabs. */
export function isAssistantView(view: SidePanelView | null | undefined): boolean {
  return view !== null && view !== undefined && PROJECT_VIEWS.includes(view);
}
